<template>
  <div>
    <vx-card title="Salary" subtitle="Lists of Employee Salaries" class="no-scroll-content">


      <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
      <vs-button type="gradient" color="primary" @click="promptAddNewSalary()" icon-pack="feather"
        icon="icon-plus">Add</vs-button>

      <div class="vx-col w-full mb-base">
        <template>
          <vs-table stripe v-model="selected" search :data="employeeSalary">
            <template slot="thead">
              <vs-th>Monthly Rate</vs-th>
              <vs-th>Daily Rate</vs-th>
              <vs-th>Hourly Rate</vs-th>
              <vs-th>Working Hours per Day</vs-th>
              <vs-th>Annual Working Days</vs-th>
              <vs-th>From Date</vs-th>
              <vs-th>To Date</vs-th>
              <vs-th>Used?</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].monthlyRate">
                  {{ data[indextr].monthlyRate }}
                </vs-td>
                <vs-td :data="data[indextr].dailyRate">
                  {{ data[indextr].dailyRate }}
                </vs-td>
                <vs-td :data="data[indextr].hourlyRate">
                  {{ data[indextr].hourlyRate }}
                </vs-td>
                <vs-td :data="data[indextr].workHoursPerDay">
                  {{ data[indextr].workHoursPerDay }}
                </vs-td>
                <vs-td :data="data[indextr].annualWorkingDays">
                  {{ data[indextr].annualWorkingDays }}
                </vs-td>
                <vs-td :data="data[indextr].fromDate">
                  {{ data[indextr].fromDate | fulldate }}
                </vs-td>
                <vs-td :data="data[indextr].toDate">
                  {{ data[indextr].toDate | fulldate }}
                </vs-td>
                <vs-td :data="data[indextr].isUsed">
                  <vs-checkbox v-model="data[indextr].isUsed" disabled="true" />
                </vs-td>
                <vs-td>
                  <div :style="{ 'direction': $vs.rtl ? 'rtl' : 'ltr' }">
                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="editRecord(data[indextr].id)" />
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                      @click="confirmDeleteRecord(data[indextr].id)" />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </template>

      </div>

      <!-- ADD SALARY  -->
      <vs-prompt class="email-compose" title="Salary" accept-text="Submit" @accept="onAddSalary" :is-valid="validForm"
        :active.sync="activePromptNewSalary">
        <vx-card title="Fill-out the following information">
          <div class="vx-row mb-3">

            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Annual Working Days</span><span style="color:red">*</span>
              <vs-input v-validate="'max_value:365'" name="annual days" class="w-full" v-model="annualWorkingDays"
                placeholder="Annual Working Days" />
              <span class="text-danger text-sm" v-show="errors.has('annual days')">{{ errors.first('annual days')
                }}</span>

            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Hours per Day</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:1|max_value:12'" name="worked hours" class="w-full"
                v-model="workHoursPerDay" placeholder="Hours per Day" />
              <span class="text-danger text-sm" v-show="errors.has('worked hours')">{{ errors.first('worked hours')
                }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Monthly Rate</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:0|max_value:2000000'" name="monthly rate" class="w-full"
                v-model="monthlyRate" placeholder="Monthly Rate" />
              <span class="text-danger text-sm" v-show="errors.has('monthly rate')">{{ errors.first('monthly rate')
                }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Daily Rate</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:0|max_value:25000'" name="daily rate" class="w-full" v-model="dailyRate"
                placeholder="Daily Rate" />
              <span class="text-danger text-sm" v-show="errors.has('daily rate')">{{ errors.first('daily rate')
                }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Hourly Rate</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:0|max_value:10000'" name="hourly rate" class="w-full"
                v-model="hourlyRate" placeholder="Hourly Rate" />
              <span class="text-danger text-sm" v-show="errors.has('hourly rate')">{{ errors.first('hourly rate')
                }}</span>

            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">From</span><span style="color:red">*</span>
              <datepicker name="from date" class="w-full" v-model="fromDate" placeholder="Select Date" />
              <span class="text-danger text-sm" v-show="errors.has('from date')">{{ errors.first('from date') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">To</span>
              <datepicker name="toDate-name" class="w-full" v-model="toDate" placeholder="Select Date" />

            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full mb-2">
              <vs-checkbox v-model="isUsed">Used?</vs-checkbox>
            </div>
          </div>

        </vx-card>
      </vs-prompt>




      <!-- EDIT SALARY -->
      <vs-prompt class="email-compose" title="Salary" accept-text="Submit" @accept="onEditSalary" :is-valid="validForm"
        :active.sync="activePromptEditSalary">
        <vx-card title="Fill-out the following information">

          <div class="vx-row mb-3">

            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Annual Working Days</span><span style="color:red">*</span>
              <vs-input v-validate="'max_value:365'" name="annual days" class="w-full" v-model="annualWorkingDays"
                placeholder="Annual Working Days" />
              <span class="text-danger text-sm" v-show="errors.has('annual days')">{{ errors.first('annual days')
                }}</span>

            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Hours per Day</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:1|max_value:12'" name="worked hours" class="w-full"
                v-model="workHoursPerDay" placeholder="Hours per Day" />
              <span class="text-danger text-sm" v-show="errors.has('worked hours')">{{ errors.first('worked hours')
                }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Monthly Rate</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:0|max_value:2000000'" name="monthly rate" class="w-full"
                v-model="monthlyRate" placeholder="Monthly Rate" />
              <span class="text-danger text-sm" v-show="errors.has('monthly rate')">{{ errors.first('monthly rate')
                }}</span>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Daily Rate</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:0|max_value:25000'" name="daily rate" class="w-full" v-model="dailyRate"
                placeholder="Daily Rate" />
              <span class="text-danger text-sm" v-show="errors.has('daily rate')">{{ errors.first('daily rate')
                }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">Hourly Rate</span><span style="color:red">*</span>
              <vs-input v-validate="'min_value:0|max_value:10000'" name="hourly rate" class="w-full"
                v-model="hourlyRate" placeholder="Hourly Rate" />
              <span class="text-danger text-sm" v-show="errors.has('hourly rate')">{{ errors.first('hourly rate')
                }}</span>

            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">From</span><span style="color:red">*</span>
              <datepicker name="from date" class="w-full" v-model="fromDate" placeholder="Select Date" />
              <span class="text-danger text-sm" v-show="errors.has('from date')">{{ errors.first('from date') }}</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-4">
              <span class="text-sm">To</span>
              <datepicker name="toDate-name" class="w-full" v-model="toDate" placeholder="Select Date" />

            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full mb-2">
              <vs-checkbox v-model="isUsed">Used?</vs-checkbox>
            </div>
          </div>



        </vx-card>
      </vs-prompt>
    </vx-card>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  data() {
    return {
      selected: [],
      id: 0,
      monthlyRate: null,
      dailyRate: null,
      hourlyRate: null,
      workHoursPerDay: null,
      annualWorkingDays: null,
      fromDate: null,
      toDate: null,
      isUsed: true,
      isForOvertime: true,
      userId: null,

      paymentModeId: null,

      uid: null,
      activePromptNewSalary: false,
      activePromptEditSalary: false,

      format: "d MMMM yyyy",

      tenantsSettings: {},
    }
  },
  watch: {
    monthlyRate() {
      // this.dailyRate = parseFloat(this.roundTo(((this.monthlyRate * 12) / this.annualWorkingDays)))
      this.dailyRate = parseFloat(((this.monthlyRate * 12) / this.annualWorkingDays).toFixed(2))
      this.hourlyRate = parseFloat(this.roundTo(((this.monthlyRate * 12) / this.annualWorkingDays).toFixed(2) / this.workHoursPerDay))
      // this.hourlyRate = parseFloat(this.roundTo((((this.monthlyRate * 12) / this.annualWorkingDays) / this.workHoursPerDay)))
    },
    annualWorkingDays() {
      // this.dailyRate = parseFloat(this.roundTo(((this.monthlyRate * 12) / this.annualWorkingDays)))
      this.dailyRate = parseFloat(((this.monthlyRate * 12) / this.annualWorkingDays).toFixed(2))
      this.hourlyRate = parseFloat(this.roundTo(((this.monthlyRate * 12) / this.annualWorkingDays).toFixed(2) / this.workHoursPerDay))

      // this.hourlyRate = parseFloat(this.roundTo((((this.monthlyRate * 12) / this.annualWorkingDays) / this.workHoursPerDay)))
    },
  },
  created() {
    this.$vs.loading()
    this.$store.dispatch('lookup/getAllBankLookup')
    this.$store.dispatch('lookup/getAllPeriodLookup')
      .then(res => { this.$vs.loading.close() })
      .catch(error => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-x-octagon',
          color: 'danger'
        })
      })
    this.uid = this.$route.params.id
    this.employeeSalary = this.uid
    this.$store.dispatch('tenants/getAllSettings', { tenantsId : this.$store.state.AppActiveUser.tenantsId }).catch((err) => { console.log(err) })



  },
  computed: {
    employeeSalary: {
      get() { return this.$store.state.hrms.employeeSalary },
      set(value) { this.$store.dispatch('hrms/getAllSalary', value) }

    },

    validForm() {
      return this.monthlyRate != null && this.dailyRate != null &&
        this.workHoursPerDay != null && this.hourlyRate != '' && this.annualWorkingDays != '' && this.fromDate != null
    },
    getTenantsSchedule() {
        return this.$store.state.tenants.tenantsSchedule
    },
    getTenantsSettings() {
        return this.$store.state.tenants.tenantsSettings
    },



  },

  methods: {
    promptAddNewSalary() {
      this.activePromptNewSalary = true
    },
    onAddSalary() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()

          const data = {
            monthlyRate: this.monthlyRate,
            dailyRate: this.dailyRate,
            hourlyRate: this.hourlyRate,
            workHoursPerDay: this.workHoursPerDay !== 0 ? this.workHoursPerDay : this.tenantsSettings.hoursInADay,
            annualWorkingDays: this.annualWorkingDays !== 0 ? this.annualWorkingDays : this.tenantsSettings.annualWorkingDays,
            fromDate: this.fromDate,
            toDate: this.toDate,
            isUsed: this.isUsed,
            isForOvertime: this.isUsed,
            userId: this.uid,
            currentUserId: this.$store.state.AppActiveUser.uid
          }
          this.$store.dispatch('hrms/AddSalary', data)
            .then((response) => {
              this.employeeSalary = this.uid
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Success',
                text: 'Salary Saved',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Error',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-x-octagon',
                color: 'danger'
              })
            })
        } else {
          // form have errors
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-x-octagon',
            color: 'danger'
          })
        }
      })
    },
    onEditSalary() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const data = {
            id: this.id,
            monthlyRate: this.monthlyRate,
            dailyRate: this.dailyRate,
            hourlyRate: this.hourlyRate,
            workHoursPerDay: this.workHoursPerDay,
            annualWorkingDays: this.annualWorkingDays,
            fromDate: this.fromDate,
            toDate: this.toDate,
            isUsed: this.isUsed,
            isForOvertime: this.isUsed,
            userId: this.uid,
            currentUserId: this.$store.state.AppActiveUser.uid
          }
          this.$store.dispatch('hrms/UpdateSalary', data)
            .then(response => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Success',
                text: 'Salary Updated',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
            })
            .catch(error => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Error',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-x-octagon',
                color: 'danger'
              })
            })
        } else {
          // form have errors
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-x-octagon',
            color: 'danger'
          })
        }
      })
    },
    editRecord(Id) {

      const e = this.$store.getters['hrms/employeeSalary'](Id)
      this.id = e.id,
        this.monthlyRate = e.monthlyRate,
        this.dailyRate = e.dailyRate,
        this.hourlyRate = e.hourlyRate,
        this.workHoursPerDay = e.workHoursPerDay,
        this.annualWorkingDays = e.annualWorkingDays,
        this.fromDate = e.fromDate,
        this.toDate = e.toDate,
        this.isUsed = e.isUsed,
        this.userId = e.userId

      this.activePromptEditSalary = true
    },
    confirmDeleteRecord(id) {
      this.$store.dispatch('hrms/DeleteSalary', id)
        .then(res => {
          this.$vs.loading.close()
          this.employeeSalary = this.uid
          this.$vs.notify({
            title: 'Success',
            text: 'Salary Deleted',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-x-octagon',
            color: 'danger'
          })
        })
    },
    roundTo(num) {
      let roundOff = this.getTenantsSettings.roundOff
      let factor = Math.pow(10, roundOff);
      return Math.round(num * factor) / factor;
    },

  },
  components: {
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    // VuePerfectScrollbar,
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
